import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { IExtracurricular } from "../../models/academic";

export const ActivityActions = createActionGroup({
    source: 'Activities',
    events: {
        'Load Activities': emptyProps(),
        'Load Activities Success': props<{ activities: IExtracurricular[] }>(),
        'Load Activities Failure': props<{ error: unknown }>(),
        'Select Activity': props<{ id: string }>(),
    }
});